package dev.lingvo.site.pages.docs

import androidx.compose.runtime.Composable
import dev.lingvo.shared.agent.AgentCatalogue
import dev.lingvo.shared.agent.AgentPrompts
import dev.lingvo.shared.agent.AgentResources
import dev.lingvo.site.components.marketing.DocsSubheading
import dev.lingvo.site.components.marketing.DocAnchor
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put

private val referenceJson = Json { prettyPrint = true }

@Composable
internal fun McpToolReference() {
    AgentCatalogue.TOOLS.forEach { tool ->
        DocsSubheading(tool.name, anchor = "tool-${tool.name}")
        val declaration = buildJsonObject {
            put("name", tool.name)
            put("description", tool.summary)
            put("transports", JsonArray(tool.transports.map { JsonPrimitive(it.id) }))
            put("safety", tool.safety.id)
            put("scopes", JsonArray(tool.scopes.map { JsonPrimitive(it.id) }))
            put("minimumRole", tool.minimumRole.name)
            put("dryRunnable", tool.dryRunnable)
            put("idempotent", tool.idempotent)
            put("inputSchema", tool.input)
            tool.output?.let { put("outputSchema", it) }
        }
        ReferenceCode(referenceJson.encodeToString(JsonObject.serializer(), declaration))
    }
}

@Composable
internal fun McpContextReference() {
    AgentPrompts.PROMPTS.forEach { prompt ->
        DocsSubheading(prompt.name, anchor = "prompt-${prompt.name}")
        ReferenceCode(referenceJson.encodeToString(JsonObject.serializer(), buildJsonObject {
            put("name", prompt.name)
            put("description", prompt.description)
            put("arguments", JsonArray(prompt.arguments.map { argument -> buildJsonObject {
                put("name", argument); put("required", argument !in prompt.optional)
            } }))
        }))
    }
    (AgentResources.RESOURCES + AgentResources.TEMPLATES).forEachIndexed { index, resource ->
        DocsSubheading(resource.uriTemplate, anchor = "resource-$index")
        ReferenceCode(referenceJson.encodeToString(JsonObject.serializer(), buildJsonObject {
            put("uriTemplate", resource.uriTemplate)
            put("description", resource.description)
            resource.scope?.let { put("scope", it.id) }
        }))
    }
}

internal fun mcpContextAnchors(): List<DocAnchor> =
    AgentPrompts.PROMPTS.map { DocAnchor("prompt-${it.name}", it.name) } +
        (AgentResources.RESOURCES + AgentResources.TEMPLATES).mapIndexed { index, resource ->
            DocAnchor("resource-$index", resource.uriTemplate)
        }
